import React from "react";

class WorksPg extends React.Component{
    render(){
        return(
            <div id="section-works" className="rounded-xl works bg-headerbg p-4 md:p-8 text-white" >
                <h3 className="bg-darkmain dark:bg-mail-icon text-white rounded-full px-4 mb-2 inline-block font-medium text-base">
                    Projects & Accomplishments
                </h3>
                <p className="text-md px-2 mb-4 leading-5 text-works">
                <strong>To be ported over from <a href="https://nicklusk.com">nicklusk.com</a> very soon. Until then, please enjoy these other works below.</strong>
                </p>
                <div className="bg-darkmain dark:bg-mail-icon text-white rounded-full px-4 mb-2 inline-block font-medium text-base">
                    Published Work
                </div>
                <p className="text-md px-2 mb-4 leading-5 text-works">
                <strong><a href="https://nicklusk.com/archive/ac-snapshot-2010/alex-chilton-an-appreciation.html">Alex Chilton</a></strong>: I wrote an article about Alex Chilton when he died. He was wildly influential among people who played in rock bands.
                </p>
                <p className="text-md px-2 mb-4 leading-5 text-works">
                <strong>Emmy nominee</strong> for my contributions to <strong><a href="https://www.cnn.com/interactive/2012/03/world/mauritania.slaverys.last.stronghold/index.html " target="_blank ">Mauritania: Slavery's Last Stronghold</a></strong>
                </p>
                <p className="text-md px-2 mb-4 leading-5 text-works">
                A few of my projects from the data science classes I've taken can read here on <strong><a href="https://rpubs.com/nicklusk" target="_blank ">my Rpubs page</a></strong>.
                </p>

            </div>
        )
    }
}

export default WorksPg;